// [2026-11-05] "กำลังเล่น" ต่อค่าย/ต่อเกม — ดึงจาก /api/v1/gameonline (รวมทุกเว็บ, backend cache 60 วิ)
//   - ดึงครั้งเดียวแล้วแชร์ทุกการ์ด + รีเฟรชทุก 60 วิ (เฉพาะตอนเปิดหน้าอยู่)
//   - useGameOnline() สำหรับ function component, subscribeGameOnline(fn) สำหรับ class component
import { useEffect, useState } from 'react';
import instance from './axios-instance';
import Systems from './SystemFunction';

let data = { providers: {}, games: {}, rtpShow: false, rtp: {} };
let timer = null;
let inflight = null;
const subs = new Set();

function load() {
    if (inflight) return inflight;
    inflight = instance.get('/api/v1/gameonline?System=' + encodeURIComponent(Systems), { noLoader: true })
        .then((res) => {
            const d = res && res.data;
            if (d && d.status === 200) {
                data = { providers: d.providers || {}, games: d.games || {}, rtpShow: !!d.rtpShow, rtp: d.rtp || {} }; // rtpShow/rtp = BO › ตั้งค่า RTP
                subs.forEach((fn) => { try { fn(data); } catch (e) { } });
            }
        })
        .catch(() => { })
        .finally(() => { inflight = null; });
    return inflight;
}
function start() {
    if (timer) return;
    load();
    timer = setInterval(() => { if (!document.hidden) load(); }, 60000);
}
export function subscribeGameOnline(fn) {
    subs.add(fn); start(); fn(data);
    return () => { subs.delete(fn); if (!subs.size && timer) { clearInterval(timer); timer = null; } };
}
export function useGameOnline() {
    const [d, setD] = useState(data);
    useEffect(() => subscribeGameOnline(setD), []);
    return d;
}
export const providerOnline = (d, partner) => Number((d.providers || {})[String(partner || '').toUpperCase()] || 0);
export const gameOnline = (d, partner, gameId) => Number((d.games || {})[String(partner || '').toUpperCase() + '|' + String(gameId || '')] || 0);
// RTP ของเกม: ค่าในรายการเกม (ถ้ามี) หรือจาก map ที่ backend ส่งมา (ไม่ต้องรอแคชรายการเกม)
export const gameRtp = (d, item, partner) => { if (!d || !d.rtpShow || !item) return 0; const v = Number(item.rtp) || Number((d.rtp || {})[String(item.partner || partner || '').toUpperCase() + '|' + String(item.gameId || '')]) || 0; return v; };
// ระดับสีป้าย RTP: lv4 ≥ 98 · lv3 97–97.99 · lv2 96–96.99 · lv1 < 96
export const rtpLevel = (v) => (v >= 98 ? 4 : v >= 97 ? 3 : v >= 96 ? 2 : 1);
export const fmtOnline = (n) => Number(n || 0).toLocaleString('en-US');
